import React, { useContext } from 'react'
import { Pagination, FABFixed, ErrorBanner, PageContainer, DeleteConfirmationDialog } from 'components'
import AddIcon from '@material-ui/icons/Add'
import IconButton from '@material-ui/core/IconButton'
import MuiList from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import RegionIcon from '@material-ui/icons/MyLocation'
import EditIcon from '@material-ui/icons/Edit'
import { errorStringsFromError } from 'utils'
import { SnackbarContext, RegionsContext } from 'contexts'
import { usePagination, useDependency } from 'hooks'
import { useHistory } from 'react-router-dom'

const List = () => {
  const regions = useContext(RegionsContext.ReactContext)
  const snackbar = useContext(SnackbarContext.ReactContext)

  const history = useHistory()

  const [page, setPage] = usePagination('regions')

  const [, , reloadRegions] = useDependency(() => (
    regions.actions.index({
      page: page,
      fields: {regions: 'name'}
    })
  ), [page])

  const showRegion = ({id}) => () => {
    history.push(`/regions/${id}`)
  }

  const editRegion = ({id}) => event => {
    history.push(`/regions/${id}/edit`)
    event.stopPropagation()
  }

  const deleteRegion = ({id}) => event => {
    regions.actions.destroy({id})
                .then(reloadRegions)
                .catch(error => snackbar.actions.show(errorStringsFromError(error).join(', ')))
  }

  const renderRegionListItem = (region) => {
    const { id, name } = region
    return (
      <ListItem button onClick={showRegion(region)} key={id}>
        <ListItemIcon>
          <RegionIcon />
        </ListItemIcon>
        <ListItemText primary={name}/>
        <ListItemSecondaryAction>
          <IconButton onClick={editRegion(region)}><EditIcon/></IconButton>
          <DeleteConfirmationDialog onConfirm={deleteRegion(region)} entityName="region" />
        </ListItemSecondaryAction>
      </ListItem>
    )
  }

  return (
    <PageContainer>
      <ErrorBanner>
        {errorStringsFromError(regions.actions.apiErrorsFor('index', 'destroy'))}
      </ErrorBanner>
      <Pagination totalPages={regions.totalPages} page={page} onPageSelected={setPage}/>
      <MuiList dense>
        {regions.list.map(renderRegionListItem )}
      </MuiList>
      <Pagination totalPages={regions.totalPages} page={page} onPageSelected={setPage}/>
      <FABFixed color='primary' onClick={() => history.push('/regions/new')}>
        <AddIcon/>
      </FABFixed>
    </PageContainer>
  )
}

const Component = (props) => (
  <RegionsContext>
    <List {...props} />
  </RegionsContext>
)
export default Component